// extracted by mini-css-extract-plugin
export default {"rightnavigationContainer":"RightNavigation_rightnavigationContainer__3O39T"};